"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledDiscountsHeading=exports.DiscountsContainer=exports.DiscountStyledTable=void 0;const DiscountsContainer=exports.DiscountsContainer=_styledComponents.default.div`
    padding-top: 0.5rem;
    text-align: center;
`,StyledDiscountsHeading=exports.StyledDiscountsHeading=_styledComponents.default.div`
  display: flex;
  justify-content: center;
  background-color: #eaeaea;
  text-align: center;
  padding: 4px 0px;

  .dept-heading {
    color: white;
    border: 0.5px solid;
    border-radius: 20px;
    background: #514f50;
    padding: 8px;
    font-weight: 600;
  }
`,DiscountStyledTable=exports.DiscountStyledTable=_styledComponents.default.table`
  border: none;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  table-layout: fixed;
  width: 100%;

  td {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }

  td:first-child {
    padding: 0.375rem 0 0.375rem 1rem;
    text-align: left;
  }

  td:last-child {
    text-align: right;
    padding-right: 1.5rem;
  }

  tr {
     border-bottom: 1px solid #c8c7cc;
  }

  tr:last-child {
    border: none;
  }

  .brownred {
    color: #7B1A27;
  }
`;